import { useStaticQuery, useStaticMutation } from '../../../helpers/useStaticData';
import { getFoodsResponse, getFoodLikes } from '../../../helpers/data';

export const useGetFoodQuery = () => useStaticQuery(() => getFoodsResponse());

export const useGetLikeFoodQuery = () => useStaticQuery(() => getFoodLikes());

export const useAddFoodLikeMutation = () => useStaticMutation();

export const useDeleteFoodLikeMutation = () => useStaticMutation();
